import { createRouter, createWebHistory } from 'vue-router'
import { bindThirdPartyApi } from '@/api/auth'
import { useUserStore } from '@/store/modules/user.ts'
import { setCookie } from '@/utils/cookie.ts'
import routes from './routes/index.ts'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），使用保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到顶部
    return { top: 0 }
  },
})

router.beforeEach((to, _from, next) => {
  // 处理邀请链接
  if (to.query.invite) {
    const inviteCode = String(to.query.invite)
    // 存储邀请码到 cookie，有效期30天
    setCookie('inviteCode', inviteCode, 30)
    // 直接跳转到首页
    next('/')
    return
  }

  if (to.path === '/wechat/bind/callback') {
    const code = to.query.code
    if (!code) {
      next('/settings/safe')
      return
    }
    bindThirdPartyApi(String(code))
      .then((res: any) => {
        if (res.code === 0) {
          void useUserStore().getMemberInfo()
        }
      })
      .finally(() => next('/settings/safe'))
    return
  }

  next()
})

export default router
